export const DRAWER_WIDTH = 215;
export const MENU_TYPE = {
    HOME: 0,
    JOB_OFFER: 1,
    CHECKIN: 2,
    MODIFICATION_LIST: 3,
    CHAT_LIST: 4,
    PAYMENT: 5,
    RECEIPT_LIST: 6,
    ACCOUNT: 7,
    LOGOUT: 8,
};
export const MENU = [
    { title: 'ホーム', icon: 'home', path: '/home', type: 'HOME' },
    { title: '求人管理', icon: 'list', path: '/home/job_offer', type: 'JOB_OFFER' },
    { title: 'チェックイン管理', icon: 'center_focus_strong', path: '/home/checkin', type: 'CHECKIN' },
    { title: '修正依頼一覧', icon: 'warning', path: '/home/modification_list', type: 'MODIFICATION_LIST' },
    { title: 'やりとり一覧', icon: 'message', path: '/home/chat_list', type: 'CHAT_LIST' },
    { title: '支払い処理', icon: 'credit_card', path: '/home/payment', type: 'PAYMENT' },
    { title: '領収書一覧', icon: 'assignment', path: '/home/receipt_list', type: 'RECEIPT_LIST' },
    { title: 'アカウント情報', icon: 'account_circle', path: '/home/account', type: 'ACCOUNT' },
    { title: 'ログアウト', icon: 'logout', path: undefined, type: 'LOGOUT' },
];
export const COLOR = {
    AQUA_GREEN100: '#f2fffe',
    AQUA_GREEN500: '#a7dbd8',
    AQUA_GREEN700: '#59d3b6',
    ORANGE700: '#f38630',
    CHERRY_RED700: '#e10050',
    GRAY_300: '#ccc',
    GRAY_500: '#aaa',
};
export const REGEX = {
    EMAIL: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i,
    TEL: /^0\d{9,10}$/,
    NUMBER: /^\d+$/,
};
